import React, { useState, useEffect } from 'react';
import { Alert, Space } from 'antd';

import NotificacionServices from "../../services/NotificacionServices";
import Marquee from "react-fast-marquee";


const Avisos = () => {
  const [notificaciones, setNotificaciones] = useState([]);

  useEffect(() => {
    getNotificaciones();
  }, []);

  const getNotificaciones = async () => {
    const response = await NotificacionServices.getNotificacionsByUser();
    if (!response.success) return;
    setNotificaciones(response.data);
  }
  if (!notificaciones?.length) return null
  return <>
    <Marquee key={`avisos`} pauseOnHover={true} gradient={false} speed={40} >
      <Space
        size={30}
      >
        {notificaciones.map(({ id_notificacion, notificacion, estatus }) => (
          <Alert
            id={`v_${id_notificacion}`}
            key={id_notificacion}
            banner
            showIcon
            message={notificacion}
            type={estatus}
            size="small"
          />
        ))}
      </Space>
    </Marquee>

  </>

};

export default Avisos; 